export default __webpack_public_path__ + "static/media/DSC_1897.f1bc8b95.jpg";